import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../store/store';
import baseServices from "../../services/base.services";
//import { fetchCount } from './counterAPI';

export interface HomeState {
  value: number;
  selectedRange: string;
  status: 'idle' | 'loading' | 'failed';
  comment: string | null;
  result: boolean | null;
  code: number | null;
}

const initialState: HomeState = {
  value: 0,
  selectedRange: 'D',
  status: 'idle',
  comment: '',
  result: null
};
//////////////////////////

export const addResult = createAsyncThunk(
  'addResult',
  async (_props: any) => {
    var data: any = {};
    {/*@ts-ignore*/}
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(user)
    const response1 = await baseServices.addResult({
      IdApp		: 1,
      Rut: user.data.rut,
      IdQuestion : 1,
      Question:	'Comentario',
      IdResponse : 1,
      Response: _props.comment,
      Code: _props.code
    });
    data = response1.data[0];

    return data;
  }
);

export const getCode = createAsyncThunk(
  'getCode',
  async (_props: any) => {
    var data: any = {};
    {/*@ts-ignore*/}
    let user = JSON.parse(localStorage.getItem('user'));
    const response1 = await baseServices.getCode({});
    data = response1.data[0];

    return data.Code;
  }
);

export const homeSlice = createSlice({
  name: 'range',
  initialState,

  reducers: {
    changeRangeDate: (state: any, action:any) => {
      state.selectedRange = action.payload;
    },
    changeComment: (state: HomeState, action:any) => {
      state.comment = action.payload;
    },
    
  },

  extraReducers: (builder : any) => {
    builder
      .addCase(addResult.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(addResult.fulfilled, (state: HomeState, action: any) => {
        state.status = 'idle';
        state.result = true;
      })
      .addCase(getCode.pending, (state: HomeState) => {
        state.status = 'loading';
      })
      .addCase(getCode.fulfilled, (state: HomeState, action: any) => {
        state.status = 'idle';
        state.code = action.payload;
      })
      ;
  },
});

export const { changeRangeDate, changeComment} = homeSlice.actions;
export const selectedDateRange = (state: RootState) => state.homePageReducer.selectedRange;


export default homeSlice.reducer;
